<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18.52" height="11.058" viewBox="0 0 18.52 11.058">
    <defs>
      <clipPath id="clip-path">
        <rect id="Rectangle_1017" data-name="Rectangle 1017" width="18.52" height="11.058" fill="#fff"/>
      </clipPath>
    </defs>
    <g id="Group_682" data-name="Group 682" clip-path="url(#clip-path)">
      <path id="Path_291" data-name="Path 291" d="M.4,5.882H18.253a.333.333,0,1,0,0-.665H.734V.333a.333.333,0,1,0-.665,0V5.549A.334.334,0,0,0,.4,5.882Z" transform="translate(-0.069)" :fill="color"/>
      <path id="Path_292" data-name="Path 292" d="M.333,11.678a.34.34,0,0,0,.236-.1L5.743,6.4a.331.331,0,0,0,0-.469L.569.756A.331.331,0,0,0,.1,1.225L5.034,6.169.1,11.113a.331.331,0,0,0,0,.469.327.327,0,0,0,.236.1Z" transform="translate(12.68 -0.62)" :fill="color"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "ReturnIcon",
  props: {
    color: {
      type: String,
      required: false,
      default: '#fff'
    }
  },
}
</script>

<style scoped>

</style>